import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette, spacing }) =>
  createStyles({
    root: {
      display: 'flex',
      flexFlow: 'column',
      height: '100vh',

      padding: spacing(6),

      '& > header': {
        marginBottom: spacing(1),
      },

      '& > div': {
        display: 'grid',
        gridTemplateColumns: '1fr 1.4fr',
        gridGap: spacing(8),

        '& > section': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',

          '& > h1': {
            fontSize: '3rem',
            fontWeight: 500,
          },

          '& > p': {
            marginTop: spacing(4),
            fontSize: '2rem',
          },
        },

        '& > img': {
          width: '100%',
          border: '5px solid ' + palette.secondary.main,
          borderRadius: '1rem',
        },
      },

      '& > button': {
        alignSelf: 'end',
        justifySelf: 'end',

        marginTop: spacing(5),
      },

      '& > img': {
        position: 'fixed',
        bottom: '-6rem',
        left: '-11rem',
        width: '22rem',

        opacity: 0.3,
        userSelect: 'none',
      },
    },
  }),
)
